var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"pb-7 pt-5 pt-md-8",attrs:{"type":"gradient-default"}}),(_vm.entidade)?[(_vm.entidade.ent_diario_html)?[_c('pesquisa-avancada')]:[_c('pesquisa-antiga')]]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }